var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-review-answer" },
    [
      _c("product-review-head", {
        staticClass: "product-user-review__head",
        attrs: { date: _vm.date, answer: "" }
      }),
      _c("message-cloud", { attrs: { answer: "", text: _vm.text } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }